var BaseEvent = require('./base-event.js');

module.exports = BaseEvent(eventLambda);

function eventLambda(ev, broadcast) {
    broadcast(this.data);
}



//////////////////
// WEBPACK FOOTER
// ./~/value-event/event.js
// module id = 57
// module chunks = 0